import { render, staticRenderFns } from "./MenuPhysicalEducator.vue?vue&type=template&id=0f66e110&"
import script from "./MenuPhysicalEducator.vue?vue&type=script&lang=js&"
export * from "./MenuPhysicalEducator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports